var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nv-model',{attrs:{"id":_vm.id,"prev":_vm.prev,"next":_vm.next,"info":_vm.info,"is-rotate":_vm.isRotate90,"title":_vm.info.title,"initScale":0.5},on:{"on-load":_vm.onImgLoad,"go":_vm.goImg}})}
var staticRenderFns = []

export { render, staticRenderFns }